
import React from 'react';
import { Form } from "@/components/ui/form";
import { useClientForm } from '@/hooks/useClientForm';
import PersonalInfoSection from '../form-sections/PersonalInfoSection';
import AddressSection from '../form-sections/AddressSection';
import InvoiceDataSection from '../form-sections/InvoiceDataSection';
import AdditionalInfoSection from '../form-sections/AdditionalInfoSection';
import SubmitFormButton from '../payment-form/SubmitFormButton';
import PaymentBreakdownDialog from '../payment-form/PaymentBreakdownDialog';

interface PaymentFormWrapperProps {
  selectedOffer: 'standard' | 'premium' | 'exclusive';
  offerPrice: number;
  onSubmitSuccess: () => void;
  numberOfRooms: number;
  roomAreas: number[];
  installationType: 'home' | 'company';
}

const PaymentFormWrapper: React.FC<PaymentFormWrapperProps> = ({ 
  selectedOffer, 
  offerPrice,
  onSubmitSuccess,
  numberOfRooms,
  roomAreas,
  installationType
}) => {
  console.log('PaymentFormWrapper - values:', { numberOfRooms, roomAreas });
  
  const { 
    form, 
    showPaymentBreakdown, 
    setShowPaymentBreakdown,
    isSubmitting,
    processingStep,
    progressValue,
    processingSteps,
    handleUsePersonalData,
    onSubmit,
    handlePaymentConfirm,
    isUsePersonalDataChecked
  } = useClientForm({
    selectedOffer,
    offerPrice,
    onSubmitSuccess,
    numberOfRooms,
    roomAreas,
    installationType
  });

  return (
    <>
      <Form {...form}>
        <form onSubmit={onSubmit} className="space-y-8">
          {/* Dane osobowe */}
          <PersonalInfoSection control={form.control} />
          
          {/* Adres instalacji */}
          <AddressSection control={form.control} />
          
          {/* Dane do faktury */}
          <InvoiceDataSection 
            control={form.control} 
            onUsePersonalData={handleUsePersonalData}
            isUsePersonalDataChecked={isUsePersonalDataChecked}
            installationType={installationType}
          />
          
          {/* Dodatkowe informacje i akceptacja regulaminu */}
          <AdditionalInfoSection control={form.control} />
          
          <SubmitFormButton 
            isSubmitting={isSubmitting}
            processingStep={processingStep}
            progressValue={progressValue}
            processingSteps={processingSteps}
          />
        </form>
      </Form>
      
      {/* Payment Breakdown Dialog */}
      <PaymentBreakdownDialog 
        isOpen={showPaymentBreakdown}
        onClose={() => setShowPaymentBreakdown(false)}
        onConfirm={handlePaymentConfirm}
        totalAmount={offerPrice}
      />
    </>
  );
};

export default PaymentFormWrapper;
